export default "__VITE_PUBLIC_ASSET__96594510__"